import type { CalendarColor } from '@/types/database';

/**
 * Literal Tailwind class maps for the calendar colour tokens (events +
 * tags). Kept as flat records so the Tailwind JIT picks up the class
 * names at build time — same pattern as KIND_DOT_CLASS in Sidebar.tsx.
 */

export const CALENDAR_COLORS: CalendarColor[] = [
  'slate',
  'red',
  'orange',
  'amber',
  'green',
  'teal',
  'blue',
  'indigo',
  'purple',
  'pink',
];

/** Solid dot / swatch fill. */
export const CALENDAR_DOT_CLASS: Record<CalendarColor, string> = {
  slate: 'bg-slate-500',
  red: 'bg-red-500',
  orange: 'bg-orange-500',
  amber: 'bg-amber-500',
  green: 'bg-green-600',
  teal: 'bg-teal-600',
  blue: 'bg-blue-600',
  indigo: 'bg-indigo-600',
  purple: 'bg-purple-600',
  pink: 'bg-pink-600',
};

/** Event chip in a day cell — soft background + readable text + left bar. */
export const CALENDAR_CHIP_CLASS: Record<CalendarColor, string> = {
  slate: 'bg-slate-100 text-slate-900 border-slate-400 hover:bg-slate-200',
  red: 'bg-red-100 text-red-900 border-red-400 hover:bg-red-200',
  orange: 'bg-orange-100 text-orange-900 border-orange-400 hover:bg-orange-200',
  amber: 'bg-amber-100 text-amber-900 border-amber-400 hover:bg-amber-200',
  green: 'bg-green-100 text-green-900 border-green-500 hover:bg-green-200',
  teal: 'bg-teal-100 text-teal-900 border-teal-500 hover:bg-teal-200',
  blue: 'bg-blue-100 text-blue-900 border-blue-500 hover:bg-blue-200',
  indigo: 'bg-indigo-100 text-indigo-900 border-indigo-500 hover:bg-indigo-200',
  purple: 'bg-purple-100 text-purple-900 border-purple-500 hover:bg-purple-200',
  pink: 'bg-pink-100 text-pink-900 border-pink-500 hover:bg-pink-200',
};

export const CALENDAR_COLOR_LABELS: Record<CalendarColor, string> = {
  slate: 'Slate',
  red: 'Red',
  orange: 'Orange',
  amber: 'Amber',
  green: 'Green',
  teal: 'Teal',
  blue: 'Blue',
  indigo: 'Indigo',
  purple: 'Purple',
  pink: 'Pink',
};
